let influencers_glide;

function initShopByBrandsGlide() {
  if (window.innerWidth < 992) {
    if (!influencers_glide) {
      influencers_glide = new Glide(".solstice__influence-glide", {
        perView: 2,
        bound: true,
        breakpoints: {
          600: {
            perView: 1,
          },
        },
      });
      influencers_glide.mount();
    }
  } else {
    if (influencers_glide) {
      influencers_glide.destroy();
      console.log("killed the thing");
      influencers_glide = null;
    }
  }
}

// Run on load
initShopByBrandsGlide();

// Run on resize (debounced for performance)
let resizeTimerInfluencers;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimerInfluencers);
  resizeTimerInfluencers = setTimeout(initShopByBrandsGlide, 200);
});
